import React, {ChangeEvent, FC, useEffect, useState} from 'react';
import {GxIcon} from '@garpix/garpix-web-components-react';
import {components} from 'react-select';
import {useStoreon} from 'storeon/react';
import {AsyncPaginate} from 'react-select-async-paginate';
import cn from 'classnames';
import { getLoadUserOptions } from '@/apps/Applications/helpers';
import { Events, State } from '@/interfaces';
import styles from './styles/index.module.scss';
import {customMultiSelectUserStyles} from '../../../../consts';
import {ORDERS} from '../../../../../../const';
import {AnketaIcon} from '../../../../../../assets';

interface IMultiSelect{
  countMax: number;
  value: any;
  onChange: (e: Array<Record<string, any>> | ChangeEvent<any>) => void,
  onClickSingleValue: (val: any) => void,
  width?: number,
  menuPlacement?: 'auto' | 'top',
  isDisabled?: boolean
}

const MultiSelectUsers: FC<IMultiSelect> = (props) => {
  const {
    countMax,
    value,
    onChange,
    width = 426,
    menuPlacement = 'auto',
    isDisabled,
    onClickSingleValue
  } = props;
  const { typeOrder } = useStoreon<State, Events>('typeOrder');
  const [values, setValue] = useState<any>([]);
  const [inputValue, setInputValue] = useState('')

  const loadOptions = (search:string) => {
    return getLoadUserOptions({search, typeOrder})
  }
  
  const Menu = (props:any) => {
    const {children} = props
    const optionSelectedLength = props.getValue().length || 0;
    return (
      <components.Menu {...props}>
        {optionSelectedLength < countMax ? (
          children
        ) : (
          <div style={{ margin: 15 }}>Вы можете выбрать не больше {countMax} участника(ов)</div>
        )}
      </components.Menu>
    );
  }

  const MultiValueLabel  = (props: any) => {
    const {data} = props;

    const onClick = () => {
      onClickSingleValue(data)
    }

    return (
        <button onClick={onClick} type="button" className={cn(styles['item'], styles['item__button'])}>
          <div className={styles['container']}>
            <span className={styles['container--label']}>{data.label}</span>
            <GxIcon src={AnketaIcon} className={styles['container--icon']}
                    style={{color: data[ORDERS.PIPE === typeOrder ? 'acceptance_date_for_airtube' : 'acceptance_date_for_wave'] !== null ? 'green' : 'red'}}/>
          </div>
        </button>
    )
  }

  useEffect(()=>{
    setValue(value)
  },[value])

  const selectStyle = {
    ...customMultiSelectUserStyles,
    control: (provided: Record<string, any>) => ({
      ...provided,
      width,
      '@media screen and (max-width:810px)':{
        width:'100%'
      }
    }),
  }
  return (
    <AsyncPaginate
      menuPlacement={menuPlacement}
      aria-labelledby="label-users"
      components={{Menu, MultiValueLabel }}
      isMulti
      name="users"
      value={values}
      className={styles['item-select']}
      onChange={(e:any)=>{
        onChange(e);
        setValue(e);
      }}
      onInputChange={(e: any,{action}) => {
        if (
            action === 'menu-close' ||
            action === 'input-blur'
        ) {
          return false;
        }
        return setInputValue(e);
      }}
      inputValue={inputValue}
      isClearable={false}
      isDisabled={isDisabled}
      placeholder='Выберите'
      loadOptions={loadOptions}
      styles={selectStyle}
      noOptionsMessage={()=>'Ничего не найдено'}
      loadingMessage={()=>'Поиск...'}
    />
  );
};

export default MultiSelectUsers;